import axios from 'axios';
import { GET_CANTON_API_URL } from '../Optics/OpticApiConfig';

export async function fetchCantonData() {
    try {
      const token = localStorage.getItem('token');

      const resultCanton = await axios.get(GET_CANTON_API_URL,{
        headers: {
          'Authorization': `Bearer ${token}`
      }
      });
      return resultCanton.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  }
  
  export async function sampleCanton(setCanton) {
    const cantonData = await fetchCantonData();
    if (cantonData) {
      setCanton(cantonData);
    }
  }


  